module.exports = require('@apollo/client');